import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { PaymentCard } from "../../../clients.models";

@Component({
    templateUrl: 'payment-card-details-dialog.html',
    styleUrl: 'payment-card-details-dialog.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButtonModule,
        MatDialogModule,
    ]
})
export class PaymentCardDetailsDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { card: PaymentCard }) {
        this.sourceJson = this.formatJson(data.card.source);
    }

    public sourceJson: string;

    private formatJson(source: string): string {
        if (!source) return '';
        try {
            return JSON.stringify(JSON.parse(source), null, 2);
        } catch {
            return source;
        }
    }
}
